import {
  normalizeCountryCode,
  resolveCountryPreference,
} from "./countryPreference";

export type { CountryPreferenceSource as PhoneCountrySource } from "./countryPreference";

export function normalizePhoneCountryCode(value: string | null | undefined) {
  return normalizeCountryCode(value);
}

export function resolvePhoneCountryPreference(
  args: Parameters<typeof resolveCountryPreference>[0],
) {
  return resolveCountryPreference(args);
}
